import React, { useState } from 'react';
import { inputCls } from '../shared';

export default function LoginPage({ onLogin, onBack }) {
  const [email, setEmail] = useState('');
  const [pw, setPw] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = e => {
    e.preventDefault();
    setLoading(true);
    setTimeout(() => { setLoading(false); onLogin({ email, password: pw }); }, 800);
  };

  return (
    <div className="pip-root" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div className="glass-strong rounded-2xl p-8 w-full max-w-sm mx-4 animate-scale-in" style={{ position: 'relative' }}>
        <button
          onClick={onBack}
          className="btn-ghost"
          style={{ position: 'absolute', top: 16, left: 16, padding: '6px 10px', fontSize: 13, gap: 4 }}
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/></svg>
          Back
        </button>
        <div className="flex flex-col items-center mb-8">
          <div className="flex h-12 w-12 items-center justify-center rounded-xl shadow-md mb-4" style={{ background: 'var(--adani-gradient)' }}>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="white"><path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>
          </div>
          <h1 className="font-google text-xl font-semibold text-[var(--adani-text-primary)]">Digital Command Center</h1>
          <p className="text-[13px] text-[var(--adani-text-secondary)] mt-1">Sign in to access your dashboard</p>
        </div>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-[13px] font-medium text-[var(--adani-text-secondary)] mb-1.5">Email</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="admin@adani.com" className={inputCls} required />
          </div>
          <div>
            <label className="block text-[13px] font-medium text-[var(--adani-text-secondary)] mb-1.5">Password</label>
            <input type="password" value={pw} onChange={e => setPw(e.target.value)} placeholder="••••••••" className={inputCls} required />
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full py-2.5 mt-1">
            {loading ? <span className="inline-block h-4 w-4 border-2 border-white/30 border-t-white rounded-full" style={{ animation: 'pipSpin .6s linear infinite' }} /> : 'Sign In'}
          </button>
        </form>

        <p className="mt-6 text-center text-[11px] text-[var(--adani-text-tertiary)]">Adani Group · Digital Command Center</p>
      </div>
    </div>
  );
}
